import { render, staticRenderFns } from "./MonitorTriggerTable.vue?vue&type=template&id=edb3b45c"
import script from "./MonitorTriggerTable.vue?vue&type=script&lang=js"
export * from "./MonitorTriggerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports